import {ResponsePersonData} from "../../models/general/person/response-models/response-person-data";
import {ContactTypes} from "../../utills";
export const getPrimaryEmail = (personData: ResponsePersonData): string => {
    const contact = personData.personContacts.find(contact => contact.isPrimary && contact.contactTypeId === ContactTypes.EMAIL);
    if (contact) {
        return  contact.contactValue;
    }
}